import Vue from "vue";
import { mapGetters, mapMutations, mapState } from "vuex";

import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridAction } from "@/components/child/grid/gridAction";
import { GridColors, GridColumn, GridColumnType, GridColumnWithoutSort } from "@/components/child/grid/gridColumn";
import ConfiguracoesImpresaoXLSComponent from "@/components/parent/relatorio/configuracoesImpresaoXLS";
import configuracoesImpresaoXLSComponent from "@/components/parent/relatorio/configuracoesImpresaoXLS.vue";
import { Component } from "@/decorators";
import PaginationPackModel from "@/models/auxiliar/paginationPackModel";
import ConfiguracaoImpressaoModel from "@/models/configuracaoImpressaoModel";
import EnumExtensions from "@/models/enum/extensions/enumExtensions";
import SituacoesVenda from "@/models/enum/situacoesVenda";
import NotaFiscalEmissaoEmLoteVendaModel from "@/models/notafiscaleletronica/notaFiscalEmissaoEmLoteVendaModel";
import PaginationModel from "@/models/paginationModel";
import TransportadoraModel from "@/models/transporte/transportadoraModel";
import UsuarioModel from "@/models/usuarioModel";
import ValidationErrorModel from "@/models/validationErrorModel";
import notaFiscalEletronicaEmissaoLoteService from "@/services/notaFiscal/emissaoEmLote/notaFiscalEletronicaEmissaoLoteService";
import setorService from "@/services/setorService";
import tipoVendaService from "@/services/tipoVendaService";
import localEntregaService from "@/services/transporte/localEntregaService";
import TransportadoraService from "@/services/transporte/transportadoraService";
import vendedorService from "@/services/vendedorService";
import { AppState, Getters, Mutations, SessionActions } from "@/store/store";
import { convertToDateInputString } from "@/utils/common/date";
import Delay from "@/utils/common/delay";
import FileHelper from "@/utils/common/fileHelper";

import "@/components/parent/crud/crud.scss";

@Component({
    components: {
        gridComponent,
        dateTimePickerComponent,
        comboComponent,
        configuracoesImpresaoXLSComponent,
        checkboxComponent,
    },
    computed: {
        ...mapState({
            loadingPack: (state: AppState) => state.paginationStatus.loading,
            paginationParams: (state: AppState) => state.paginationStatus.paginationParams,
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
        ...mapGetters(["GET_IS_FRACIONAMENTO"] as Getters),
    },
    methods: mapMutations(["GET_PARAMS"] as Mutations),
})
export default class NotaFiscalTransporteEmissaoEmLoteComponent extends Vue {
    // State computed props
    loadingPack: boolean;
    paginationParams: PaginationPackModel;
    usuarioLogado: UsuarioModel;
    SET_PARAMS: (obj: object) => void;
    GET_PARAMS: (path: string) => Promise<void>;
    GET_IS_FRACIONAMENTO: () => Promise<boolean>;

    private configuracoesImpresaoXLSComponent: ConfiguracoesImpresaoXLSComponent = null;

    private transportadoraService = new TransportadoraService();

    gridSelectedValues: Array<NotaFiscalEmissaoEmLoteVendaModel> = [];
    gridData: Array<NotaFiscalEmissaoEmLoteVendaModel> = [];
    private isFracionamento = false;

    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumnWithoutSort("clienteNome", "Cliente", GridColumnType.String),
            new GridColumnWithoutSort("codigo", "Cód. Venda", GridColumnType.String),
            new GridColumnWithoutSort("dataAprovacao", "Data Venda", GridColumnType.DateTime),
            new GridColumnWithoutSort("situacaoDescricao", "Situação", GridColumnType.String),
            new GridColumnWithoutSort("valorFinal", "Valor", GridColumnType.Money),
            new GridColumnWithoutSort("localEntrega", "Local de Entrega", GridColumnType.String),
            new GridColumnWithoutSort("dataEntrega", "Data de Entrega", GridColumnType.DateTime),
            new GridColumnWithoutSort("transportadora", "Transportadora", GridColumnType.String),
            new GridColumnWithoutSort("setor", "Setor", GridColumnType.String),
        ];
    }
    extraActions: Array<object> = [];
    extraActionsCancelar: Array<GridAction> = [];
    pageIndex = 1;
    pageSize = 20;
    total = 0;

    isHidden = false;
    situacoesVendaOptions = EnumExtensions.getNamesAndValuesOrderedByValues(SituacoesVenda);
    locaisEntregaOptions: Array<Object> = [];
    transportadoraOptions: Array<Object> = [];
    setorOptions: Array<Object> = [];

    emissaoDe = new Date(new Date().setDate(1));
    emissaoAte: Date = null;
    dataEntregaDe: Date = null;
    dataEntregaAte: Date = null;
    situacao = null;
    transportadoraId = null;
    localEntregaId = null;
    setorId = null;
    gridFilterKey = "";
    somenteComNFSe = false;
    vendedorId = 0;
    vendedoresOptions: Array<{ value: number; text: string }> = [];
    dataFaturamentoDe: Date = null;
    dataFaturamentoAte: Date = null;
    tipoVendaId = 0;
    tipoVendaOptions: Array<Object> = [];

    private async load() {
        this.situacoesVendaOptions = EnumExtensions.getNamesAndValuesOrderedByValues(SituacoesVenda);
        if (!this.isFracionamento) {
            this.situacoesVendaOptions = this.situacoesVendaOptions.slice(0, 6);
        }
        this.situacoesVendaOptions = this.situacoesVendaOptions.filter(p => p["value"] > 1 && p["value"] !== 5);

        try {
            const data = await notaFiscalEletronicaEmissaoLoteService
                .list(this.pageIndex, this.pageSize, this.gridFilterKey, this.getCustomParameters())
                .withLoading()
                .resolveWithJSON<PaginationModel<NotaFiscalEmissaoEmLoteVendaModel>>();

            this.gridData = data.list;
            this.total = data.total;
            this.pageIndex = data.pageIndex;
            this.pageSize = data.pageSize;

            this.extraActions.splice(0);
            this.extraActionsCancelar.splice(0);

            for (let i = 0; i < this.gridData.length; i++) {
                const ultimaTentativaComFalha = this.gridData[i].ultimaEmissaoStatusEnvioDescricao.length > 0;

                this.extraActionsCancelar.push(
                    new GridAction(
                        "falhaEmissao",
                        ultimaTentativaComFalha ? "Ultima tentativa de emissão falhou" : "",
                        ultimaTentativaComFalha ? "fa fa-exclamation-circle" : "",
                        GridColors.LIGHTRED,
                        ultimaTentativaComFalha,
                    ),
                );
            }

            this.extraActions.push(this.extraActionsCancelar);

            this.isHidden = false;
        } catch {}
    }

    private async loadVendedores() {
        try {
            const response = await vendedorService.comboCached(null);
            this.vendedoresOptions = response.map(u => ({
                value: u.value,
                text: u.text,
            }));
        } catch {}
    }

    private async emitirNotasLote() {
        try {
            const vendaIds = this.gridSelectedValues.map(v => v.vendaId);

            const data = await notaFiscalEletronicaEmissaoLoteService
                .emitirEmLoteByVendaIds(vendaIds)
                .withLoading()
                .resolveWithJSON<ValidationErrorModel[]>();

            if (data.length == 0) {
                this.$showSuccess(
                    "Sucesso",
                    "As notas foram enviadas para emissão, após 15 minutos serão feitas as consultas automaticamente para verificação do resultado das emissões.",
                );
            } else {
                for (let i = 0; i < data.length; i++) {
                    const element = data[i];
                    const venda = this.gridData.find(p => element.field == p.vendaId.toString());

                    await this.$showError(
                        "Erro",
                        `Não foi possível enviar a nota da venda ${venda?.codigo}: ${element.references}`,
                    );
                }
            }
        } catch {}

        this.load();
    }

    private onChangePage(pageIndex: number) {
        this.pageIndex = pageIndex;
        this.load();
    }

    private onChangePageSize(newPageSize: number) {
        this.pageIndex = 1;
        this.pageSize = newPageSize;
        this.load();
    }

    private onChangeFilterKey(filterKey: string) {
        this.gridFilterKey = filterKey;
        this.load();
    }

    private onSelectedValuesChanged(values: Array<NotaFiscalEmissaoEmLoteVendaModel>) {
        this.gridSelectedValues = values;
    }

    private async loadPagination() {
        await this.GET_PARAMS(this.$route.path);
        while (this.loadingPack) await Delay(50);

        if (this.paginationParams != null) {
            this.pageIndex = this.paginationParams.pageIndex;
            this.pageSize = this.paginationParams.pageSize;
            this.gridFilterKey = this.paginationParams.filterKey;
        }
    }

    private onExtraAction(name: string, notaFiscalEletronicaEmissaoLote: NotaFiscalEmissaoEmLoteVendaModel) {
        switch (name) {
            case "falhaEmissao":
                this.$router.push("/notafiscalsaida-edicao/" + notaFiscalEletronicaEmissaoLote.ultimaNotaFiscalId);
                break;
            default:
                break;
        }
    }

    private getCustomParameters() {
        return {
            emissaoDe: convertToDateInputString(this.emissaoDe),
            emissaoAte: convertToDateInputString(this.emissaoAte),
            dataEntregaDe: convertToDateInputString(this.dataEntregaDe),
            dataEntregaAte: convertToDateInputString(this.dataEntregaAte),
            transportadoraId: this.transportadoraId,
            localEntregaId: this.localEntregaId,
            setorId: this.setorId,
            situacao: this.situacao,
            somenteComNFSe: this.somenteComNFSe,
            vendedorId: this.vendedorId,
            dataFaturamentoDe: convertToDateInputString(this.dataFaturamentoDe),
            dataFaturamentoAte: convertToDateInputString(this.dataFaturamentoAte),
            tipoVendaId: this.tipoVendaId,
        };
    }

    private downloadPDF() {
        notaFiscalEletronicaEmissaoLoteService.exportPDF(this.gridFilterKey, this.getCustomParameters());
    }

    private async downloadXLS() {
        this.configuracoesImpresaoXLSComponent = this.$refs
            .configuracoesImpresaoXLSComponent as ConfiguracoesImpresaoXLSComponent;
        this.configuracoesImpresaoXLSComponent.open();
    }

    private async onConfirmXLS(config: ConfiguracaoImpressaoModel) {
        try {
            const response = await notaFiscalEletronicaEmissaoLoteService
                .exportXLS(this.gridFilterKey, this.getCustomParameters(), config.tipoExportacaoXLS)
                .withLoading()
                .resolveWithResponse();
            const data = await response.blob();

            const blob = new Blob([data], { type: response.headers.get("Content-Type") });
            const fileName = response.headers.get("Content-Disposition").split("filename=")[1].split(";")[0];
            FileHelper.download(blob, fileName);
        } catch {}
    }

    private async mounted() {
        await this.$store.dispatch(SessionActions.LOAD_USUARIO_LOGADO);

        this.isFracionamento = await this.GET_IS_FRACIONAMENTO();

        const response = await Promise.all([
            this.loadPagination(),
            setorService.comboCached(this.usuarioLogado.franquiaId),
            localEntregaService.comboCached(this.usuarioLogado.franquiaId),
            this.transportadoraService.combo().resolveWithJSON<PaginationModel<TransportadoraModel>>(),
            tipoVendaService.comboCached(this.usuarioLogado.franquiaId),
        ]).withLoading();

        this.setorOptions = response[1];
        this.locaisEntregaOptions = response[2];
        this.transportadoraOptions = response[3].list.map(p => ({ value: p.id, text: p.nome }));
        this.tipoVendaOptions = response[4];

        await this.loadVendedores();

        this.load();
    }
}
